import type { HTMLAttributes, MouseEvent, ReactNode } from 'react';
import './Tag.css';

export interface TagProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'onClick'> {
  selected?: boolean;
  onClick?: (e: MouseEvent) => void;
  onRemove?: (e: MouseEvent) => void;
  leftIcon?: ReactNode;
  children?: ReactNode;
}

export function Tag({
  children,
  selected = false,
  onClick,
  onRemove,
  leftIcon = null,
  style,
  ...rest
}: TagProps) {
  const clickable = Boolean(onClick);
  return (
    <span
      className={`uc-tag${selected ? ' uc-tag--selected' : ''}${clickable ? ' uc-tag--clickable' : ''}`}
      onClick={onClick}
      style={style}
      {...rest}
    >
      {leftIcon}
      {children}
      {onRemove && (
        <span
          className="uc-tag__x"
          role="button"
          aria-label="Remove"
          onClick={(e) => {
            e.stopPropagation();
            onRemove(e);
          }}
        >
          <svg
            width="11"
            height="11"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
          >
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </span>
      )}
    </span>
  );
}
